import { lazy } from 'react'

export const projectLoadables = {
	LoadableOneProject: lazy(() => import('../containers/ProjectLibrary/OneProjectView/index'))
}
